import { TextField } from '@material-ui/core';
import Select from 'react-select';
import styled, { css } from 'styled-components';
import { StyledTypography, GutterCSS } from 'styles/common';

import { LogoIcon } from 'constants/icons';

export const Container = styled.div`
  display: grid;
  ${(props) => props.theme.breakpoints.up('sm')} {
    display: grid;
    grid-template-columns: 1.5fr 2fr;
  }

  height: 100vh;
`;

export const LeftView = styled.div`
  height: 100%;
  background: white;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const RightView = styled.div`
  height: 100%;
  ${'' /* background-image: linear-gradient(120deg, #fdfbfb 0%, #ebedee 100%); */}
  display: flex;
  justify-content: flex-start;
  margin-left: 80px;
  ${
    '' /* ${props => props.theme.breakpoints.down('xs')} {
    justify-content: center;
    margin-left: 0;
  } */
  }
  align-items: center;
`;

export const ContainerNew = styled.div`
  display: grid;
  ${(props) => props.theme.breakpoints.up('sm')} {
    display: grid;
    grid-template-columns: 3fr 2fr;
  }

  height: 100vh;
`;

export const LeftViewNew = styled.div`
  height: 100%;
  background: ${({ theme }) => theme.palette.background.blue.dark.v2};
  display: flex;
  justify-content: center;
  align-items: center;
  ${(props) => props.theme.breakpoints.down(800)} {
    display: none;
  }
`;

export const RightViewNew = styled.div`
  height: 100%;
  background: white;
  ${'' /* background-image: linear-gradient(120deg, #fdfbfb 0%, #ebedee 100%); */}
  display: flex;
  justify-content: center;

  align-items: center;
`;

export const FormContainer = styled.div`
  width: 90%;
  align-self: center;
  justify-self: center;
  ${(props) => props.theme.breakpoints.up('sm')} {
    width: 50%;
  }
`;

export const StyledLogoImage = styled.img`
  width: 50%;
  height: auto;
`;

export const StyledMobileLogo = styled(LogoIcon)`
  svg {
    width: 120px;
    height: 120px;
  }
  ${({ theme }) => theme.breakpoints.up(theme.customBreakpoints.xss)} {
    top: 10%;
    svg {
      width: 150px;
      height: 150px;
    }
  }
  width: 100%;
  display: flex;
  justify-content: center;
`;

export const StyledTextField = styled(TextField)`
  input {
    background: white;
  }
  ${(props) =>
    props.gap &&
    css`
      margin-right: 4%;
    `};
  ${(props) =>
    props.half &&
    css`
      width: 48%;
    `};
`;

export const StyledTypography2 = styled(StyledTypography)`
  color: #54af50;
  font-size: 14px;
  line-height: 18px;
`;

export const ButtonContainer = styled.div`
  text-align: center;
  ${GutterCSS};
`;

export const ButtonSpacer = styled.div`
  display: inline-block;
  width: 4%;
`;

export const MeshSelect = styled(Select)`
  margin-bottom: 0.6em;
  z-index: 9;
`;

export const SubText = styled.div`
  font-size: 12px;
  margin: 0.25em 0 2em;
  color: #444;
`;

export const Label = styled.div`
  font-size: 12px;
  margin: -0.75em 0 1.5em 0;
  color: #666;
`;

export const ErrorSubText = styled.div`
  font-size: 12px;
  margin-top: -0.25em;
  color: red;
`;
